import {
  ListHeaderItem,
  ListHeaderItemDropdown,
} from "../../../../../components/_widgets/WidgetsList";

const ListFilterHeader = ({
  title,
  setSelectedCategoryChildren,
  subCategories,
  sizeLg = 2
}) => {
  return (
    <ListHeaderItem sizeLg={sizeLg} title={title}>
      <ListHeaderItemDropdown>
        <div className="filter-items" style={{ maxHeight: "238px" }}>
          <div
            onClick={() => setSelectedCategoryChildren("")}
            className="dropdown-item"
          >
            <span>Todos</span>
          </div>

          {subCategories.map((item) => (
            <div
              key={item._id}
              onClick={() => setSelectedCategoryChildren(item._id)}
              className="dropdown-item"
            >
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </ListHeaderItemDropdown>
    </ListHeaderItem>
  );
};

export default ListFilterHeader;
